export * from "./favorites-list.component";
